module.exports = __webpack_public_path__ + "media/27.ec2d9fd9.mp3";